import { extensions } from '../../extensions/Extensions.mjs';
import { BitmapTextPipe } from './BitmapTextPipe.mjs';

"use strict";
extensions.add(BitmapTextPipe);
//# sourceMappingURL=init.mjs.map
